import React from 'react';
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import Routes from "./routes";
import { AuthProvider } from './utils/AuthContext'; // Import the AuthProvider

import 'bootstrap/dist/css/bootstrap.css';
import 'leaflet/dist/leaflet.css';
import './style/main.css';
import './index.css';

Sentry.init({
  dsn: "https://945d849efde2a075da59c50540f9b660@o4509493884682240.ingest.de.sentry.io/4510132738195536",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Routes />
    </AuthProvider>
  </React.StrictMode>
);
